/**
 * @module features/display-module
 * @description Public barrel exports for the Digital Display Module (DDM) feature.
 */

export { DisplayModulePage } from "./pages/DisplayModulePage";
export * from "./types/ddm";
export * from "./api/ddmApi";
export { DdmStatusBadge, DdmArtifactTypeBadge } from "./components/DdmStatusBadge";
export { DdmNotificationTable } from "./components/DdmNotificationTable";
export { DdmArtifactFormModal } from "./components/DdmArtifactFormModal";
export { DdmSkeleton } from "./components/DdmSkeleton";

